import {
  GetUmmeldungLockStatusRequestParams,
  LockUmmeldungRequestParams,
  RefreshUmmeldungLockRequestParams,
  UnlockUmmeldungRequestParams,
} from '../../generated/api/ummeldung.serviceInterface';

export type UmmeldungLockRequestParams =
  | GetUmmeldungLockStatusRequestParams
  | LockUmmeldungRequestParams
  | RefreshUmmeldungLockRequestParams
  | UnlockUmmeldungRequestParams;

export function mapToUmmeldungLockRequestParams(vertragsnummer: string, zaehlpunktnummer: string): UmmeldungLockRequestParams {
  return {
    vertragsnummer: vertragsnummer,
    zaehlpunktnummer: zaehlpunktnummer,
  };
}
